export function getPageParam(listType: PaginationListType): string {
    return `page[${listType.toLowerCase()}]`;
}

export enum PaginationListType {
    Users = 'Users',
    Groups = 'Groups',
    Assistants = 'Assistants',
    Models = 'Models',
    Connectors = 'Connectors',
    Knowledgebases = 'Knowledgebases',
    KnowledgebaseNewFiles = 'KnowledgebaseNewFiles',
    KnowledgebaseExistingFiles = 'KnowledgebaseExistingFiles',
    ApiKeys = 'ApiKeys',
    EmbeddingModels = 'EmbeddingModels',
    VoiceModels = 'VoiceModels',
    Credentials = 'Credentials',
    AuditLogFiles = 'AuditLogFiles',
    AuthLogFiles = 'AuthLogFiles',
    DlpLogFiles = 'DlpLogFiles',
    ConnectorLogFiles = 'ConnectorLogFiles',
    ScimLogFiles = 'ScimLogFiles',
    SystemLogFiles = 'SystemLogFiles',
    SecurityLogFiles = 'SecurityLogFiles',
    OpenApiConfigs = 'OpenApiConfigs',
    McpConfigs = 'McpConfigs',
    CostsPerUser = 'CostsPerUser',
    CostsPerGroup = 'CostsPerGroup',
    CostsPerAssistant = 'CostsPerAssistant',
    CostsPerChatModel = 'CostsPerChatModel',
    CostsPerEmbeddingModel = 'CostsPerEmbeddingModel',
    CostsPerVoiceModel = 'CostsPerVoiceModel',
    CostsPerPromptFunction = 'CostsPerPromptFunction',
    DlpTrackCountPerUser = 'DlpTrackCountPerUser',
    DlpTrackCountPerGroup = 'DlpTrackCountPerGroup',
}
